import React from 'react';
import { StyledFormControl, StyledTextArea } from './styledComponents';

export function TextArea ({ fluid, ...props }) {
  return (
    <StyledFormControl fluid={fluid}>
      <StyledTextArea {...props} />
    </StyledFormControl>
  );
}